// export const site = {
//   name: "Fyrrehaven 61",
//   baseUrl: "https://fyrrehaven-61.dk", // ret hvis du kører andet domæne lokalt
//   twitter: "", // fx "@fyrrehaven61" ellers tom streng
//   defaultImage: "/og-default.jpg", // læg evt. en fil i /public
// };
export const site = {
  name: "Fyrrehaven 61",
  baseUrl: "https://fyrrehaven-61.dk", // skift til https://fyrrehaven-61.dk ved deploy
  description:
    "Fyrrehaven 61 er et familievenligt feriehus i Danmark med opvarmet pool, vildmarksbad, sauna og aktivitetsrum. Perfekt for gæster fra Danmark, Norge og Tyskland.",
  twitter: "", // fx "@fyrrehaven61" ellers tom streng
  defaultImage: "/og-default.jpg",
  robots: "index, follow",
  author: {
    name: "Fyrrehaven 61",
    url: "https://fyrrehaven-61.dk",
  },
  publisher: {
    name: "Fyrrehaven 61",
    logo: {
      "@type": "ImageObject",
      url: "https://fyrrehaven-61.dk/og-default.jpg",
    },
  },
};
